// DATA RECEIVED FROM API : only timestamps here (creation, answer sent), no business calendar date

const toDate = (value: any) => (value ? new Date(value) : null)

// GENERAL CASE : ARRAY OR PAGINATED LIST
export const afterReceiving = (data: any) => {
  if (data && Array.isArray(data))
    return data.map((object: any) => afterReceivingOne(object))

  if (data?.docs && Array.isArray(data.docs))
    data.docs = data.docs.map((object: any) => afterReceivingOne(object))

  return data
}

// SINGLE LIST ITEM
export const afterReceivingOne = (object: any) => {
  if (!object || typeof object !== 'object')
    return object
  return {
    ...object,
    _created: object._created && new Date(object._created),
    ...(object.evaluationCompleted !== undefined ? { evaluationCompleted: toDate(object.evaluationCompleted) } : {}),
  }
}

// SURVEY WITH ITS PARTICIPANTS
export const afterReceivingSurvey = (object: any) => {
  if (!object || typeof object !== 'object')
    return object
  return {
    ...object,
    _created: object._created && new Date(object._created),
    participants: (object.participants || []).map((participant: any) => ({
      ...participant,
      evaluationCompleted: toDate(participant.evaluationCompleted),
    })),
  }
}

// SURVEY AS ITS PARTICIPANT FILLS IT IN
export const afterReceivingAnswer = (object: any) => {
  if (!object || typeof object !== 'object')
    return object
  return {
    ...object,
    _created: object._created && new Date(object._created),
    participant: object.participant && {
      ...object.participant,
      evaluationCompleted: toDate(object.participant.evaluationCompleted),
    },
  }
}
